import '../style/syncfusion27.css';
import { license } from '../license';

license();

export {
  PdfViewerComponent,
  Annotation,
  BookmarkView,
  FormDesigner,
  FormFields,
  LinkAnnotation,
  Magnification,
  Navigation,
  Print,
  TextSearch,
  TextSelection,
  ThumbnailView,
  Toolbar as PdfToolbar,
  HighlightSettings,
  UnderlineSettings,
  StrikethroughSettings,
  LineSettings,
  ArrowSettings,
  RectangleSettings,
  CircleSettings,
  PolygonSettings,
  DistanceSettings,
  PerimeterSettings,
  AreaSettings,
  RadiusSettings,
  VolumeSettings,
  FreeTextSettings,
  StampSettings,
  CustomStampSettings,
  HandWrittenSignatureSettings,
  InkAnnotationSettings,
  StickyNotesSettings,
  DynamicStampItem,
  SignStampItem,
  StandardBusinessStampItem,
  DisplayMode,
  PageOrganizer,
} from '@syncfusion/ej2-react-pdfviewer';
export type { LoadEventArgs } from '@syncfusion/ej2-react-pdfviewer';
